export const FUNDRAISING_SETTINGS = 'FUNDRAISING_SETTINGS';
export const fundraisingSettings = q => ({
  type: FUNDRAISING_SETTINGS,
  payload: q
});
